/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".icon_0c9cb012{display:block;overflow:visible}\n"}]);
export const icon = "icon_0c9cb012";